import { render, staticRenderFns } from "./SphereForm.vue?vue&type=template&id=6e96c1a2&"
import script from "./SphereForm.vue?vue&type=script&lang=js&"
export * from "./SphereForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports